import React from "react";
import { useLocation } from "react-router-dom";
import { addDays } from "date-fns";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import {
    LargeWindowTitle,
} from "./styles";
import HistoryIcon from "../../assets/images/HistoryIcon.svg";
import MasterDashboardBox from '../../Components/MasterDashboardBox';

// Variables
var qtyOfOperators = 1;
var departmentNameID = 2;
var isTheFirstLoad = true;
var yearlyGoal = 100;
var animationSpeed = 10;
var timeout = null;
var refreshTimeout = 30000;
var rotation = false;

function MasterPerformanceDashboardWindow() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const isFullScreen = params.get("fullscreen") === "true";

  return (
      <div id="inputsBlock">
        <div className={isFullScreen ? "masterDashboardFullScreen" : "masterDashboard"}>
            <div className="graph-title">
            <LargeWindowTitle>
                <img src={HistoryIcon} alt="history" style={{ width: "50px", height: "50px", marginTop:'-10px'}}/>
                <span style={{marginLeft: '5px', fontSize: '48px'}}>Master Performance Dashboard</span>
                </LargeWindowTitle>

                <div className={isFullScreen ? "dashboard-grid-full-screen" : "dashboard-grid"}>
                  <MasterDashboardBox departmentNameID="0" departmentName="LIN"/> 
                  <MasterDashboardBox departmentNameID="8" departmentName="STD"/>
                  <MasterDashboardBox departmentNameID="2" departmentName="DF"/>
                  <MasterDashboardBox departmentNameID="6" departmentName="OEM"/>
                  <MasterDashboardBox departmentNameID="9" departmentName="PAINTLINE"/>
                  <MasterDashboardBox departmentNameID="3" departmentName="LADDER"/>
                </div>                                                                                                                         
            </div>
        </div>
      </div>
  );
}

export default MasterPerformanceDashboardWindow;
                           